<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="live-duration-list-box">
        <van-list
          class="live-duration-container"
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          @load="getList"
        >
          <div class="live-duration-item" v-for="item in list" :key="item.rid">
            <div class="live-duration-item-top">
              <div class="title">
                <van-icon :size="transPxToRem(16)" :name="payIcon" />
                <div class="room-name van-ellipsis">{{ item.room_name }}</div>
              </div>
              <div class="view-time">直播时间：{{ item.start_time }}~{{ item.end_time }}</div>
            </div>
            <van-divider />
            <div class="live-duration-item-bottom">
              <div class="label-box">
                <van-icon :size="transPxToRem(20)" :name="clockIcon" />
                <span class="label">观看时长</span>
              </div>
              <div>
                {{ item.duration }}
              </div>
            </div>
          </div>
        </van-list>
         <van-empty v-if="list.length == 0 && !loading" image-size="240" image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png" description="暂无观看时长" />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, computed, reactive, onMounted } from 'vue'
import { getUserWatchListApi } from '@/api/live'
import { transPxToRem } from '@/utils'
import payIcon from '@/assets/img/pay-icon.png'
import clockIcon from '@/assets/img/clock-icon.png'
import { useRoute } from 'vue-router'

const { query } = useRoute()
const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  finished.value = false
  list.value = []
  pageParams.page = 1
}

const getList = async () => {
  loading.value = true
  try {
    const resData = await getUserWatchListApi({ puid: query.fromPuid, ...pageParams })
    const resList = resData.list
    if (resList.length > 0) {
      list.value.push(...resList)
      pageParams.page++
    }
    finished.value = resList.length === 0
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    reset()
    getList()
  } finally {
    refreshing.value = false
  }
}

onMounted(async () => {
  await getList()
})
</script>

<style lang="less" scoped>
@primary-color: #fd6f54;
@font-primary-color: #ff6262;
.page-container {
  overflow: auto;
  .live-duration-list-box {
    padding-bottom: 60px;
    .live-duration-item {
      margin: 12px;
      background-color: white;
      border-radius: 8px;
      padding: 16px;
      .live-duration-item-top {
        .title {
          display: flex;
          align-items: center;
        }
        .room-name {
          margin-left: 8px;
          font-weight: bolder;
          font-size: 16px;
          color: #222222;
        }
        .view-time {
          font-size: 12px;
          color: #999999;
          margin-top: 12px;
        }
      }
      .live-duration-item-bottom {
        display: flex;
        justify-content: space-between;
        .label-box {
          display: flex;
          align-items: center;
          .label {
            margin-left: 4px;
          }
        }
      }
    }
  }
}
</style>
